import React from "react";

const ViewAmbulance = () => {
  return <div>ViewAmbulance</div>;
};

export default ViewAmbulance;
